import React from "react";
import HighchartsReact from "highcharts-react-official";
import { buildAdditionalCss, getBarChartOptions } from "./utils";
import { getClassNames } from "../../../utils";
import "./BarChart.css";
import withTheme from "../../../hocs/withTheme";

type LabelFormatter = (label: string) => string;

interface BarChartProps {
    max?: number;
    data?: number[];
    labels?: string[];
    height?: number;
    labelFormat?: LabelFormatter;
    barHeight?: number;
    className?: string;
}

function BarChart({
    max,
    data = [],
    labels = [],
    height,
    labelFormat = (label: string) => label,
    barHeight,
    className = "",
}: BarChartProps) {
    const css = buildAdditionalCss(data);

    return (
        <HighchartsReact
            containerProps={{
                style: css,
                className: getClassNames("Highcharts-bar-chart", className),
            }}
            options={getBarChartOptions(
                max,
                data,
                labels,
                height,
                labelFormat,
                barHeight
            )}
        />
    );
}

export default withTheme(BarChart);